const BoConfig = {
  mrAccessMenu:{
    ImportEmployee: "Onboarding",
    Offboarding: "Offboarding",
    AdditionalFacility: "Additional Facilty",
    FlowStatusReport: "Flow Status Report",
    Inbox: "Inbox",
    MovementList: "Movement",
    ViewEmployeeData: "View Employee Data",
    MrSubGroup: "Department",
    MrJobTitle: "Position Title",
    MrFacilitySetup: "Facility Setup",
    MrTemplate: "Template",
    MrCostCenter: "Cost Center",
    MrGaForm: "GA Form",
    MrFormChecklist: "Checklist",
    Users: "Users List",
    AccessLevel: "Access Level",
    AuditTrail: "Audit Trail",
    OnboardingChecklist: "Onboarding Checklist",
    Settings: "Settings"
  },
  mrAccessModule:{
    ApprovalCC: "Approval Costcenter",
    ITServices: "IT Services",
    GAServices: "GA Services",
  },
  sidebar: [
    {name:"Onboarding",icon:"ti-layout-grid2",link:"ImportEmployee"},
    {
      name: "Movement",
      icon: "icon-shuffle",
      link: "MovementList",
      withLock: true,
      group: 'Movement'
    },
    {
      name: "Additional Facility",
      icon: "icon-social-dropbox",
      link: "AdditionalFacility",
      group: 'AdditionalFacility'
    },
    {name:"Offboarding",icon:"ti-layout-grid2",link:"Offboarding",group:'Offboarding', withLock: true},
    {name:"Inbox",link:"Inbox",icon:"ti-email"},
    {name:"Master Settings",icon:"ti-settings",group:"Master",childs:[
      {name:"Department",link:"MrSubGroup"},
      {name:"Position Title",link:"MrJobTitle"},
      {name:"Facility Setup",link:"MrFacilitySetup"},
      {name:"Template",link:"MrTemplate"},
      {name:"Cost Center",link:"MrCostCenter"},
      {name:"GA Form",link:"MrGaForm"},
      {name:"Checklist",link:"MrFormChecklist"},
      {name:"Settings",link:"Settings"},
    ]},
    {
      name: "User Management",
      icon: "ti-user",
      group: "UserManagement",
      childs: [
      {name:"Users List",link:"Users"},
      {name:"Access Level",link:"AccessLevel"},
    ]},
    {name:"Report",icon:"icon-docs",group:"Report",childs:[
      {name:"Flow Status Report",link:"FlowStatusReport"},
      {name:"View Employee Data",link:"ViewEmployeeData"}
    ]},
    {
      name: "Audit Trail",
      link: "AuditTrail",
      icon: "ti-list"
    },
    {name:"Onboarding Checklist",icon:"ti-clipboard",link:"OnboardingChecklist"},
  ],
  mrFacilityInputType:{
    checkbox: "Multi Checkbox",
    checkbox_title: "Checkbox Title"    
  },
  mrCountry:{
    ID:"Indonesia",
    TH:"Thailand",
  },
  mrRelocationArea:{
    "Area 1": "Area 1",
    "Area 2": "Area 2",
  },
  aiStatus: {
    WFS: "Working Facility Setup",
    AHOD: "Approval Head of Department",
    ACFO: "Approval CFO",
    ACDH: "Approval CDH",
  },
  loginTimeout: 1000 * 60 * 60,
  mrServicesRole: ["ITServices","GAServices"],
  mrHRServices: ["HRLeave","HRCB","HRSeparation"],
  mrServicesRoleWF: {
    "ITServices":1,
    "GAServices":7,
  },
  mrDecision: {
    WS: "Well Suited",
    S: "Suited",
    SWL: "Suited with Limitations",
    NS: "Not Suited",
  },
  appMrStatus: {
    PRFR: "PRF Request Approval",
    SCD: "Submit Candidate Data",
    SCS: "Submit Candidate Selection",
    MIS: "Manage Interview Session",
    HIR: "HR Interview Result",
    UIR: "User Interview Result",
    MCU: "Submit MCU",
    OFFERING: "Offering",
    SPD: "Submit Personal Data",
    CDA: "Candidate Data Approval",
    HRBP: "HR BP",
    WFS: "Working Facility Setup",
    HOD: "Approval HOD",
    CFO: "Approval CFO",
    CDH: "Approval CDH",
    SRF: "Set Up Related Facility",
    CAF: "Confirmation Additional Facility",
    DONE: "DONE",
    REJECTED: "REJECTED",
  },
  mrPageLimit: {
    50: "50 page limit",
    100: "100 page limit",
    200: "200 page limit",
  },
  mrTypeChecklist: {
    "O": "Onboarding",
    "M": "Movement"
  },
  mrStatus: {
    active: "Active",
    inactive: "Inactive"
  },
  relocationPeriod: {
    3: "3 Months",
    6: "6 Months",
    9: "9 Months",
    12: "12 Months",
  }
}

export default BoConfig